export default "__VITE_ASSET__D1f642R9__"